import BaseApi from './baseApi';

export default class NotificationsApi extends BaseApi {
  static async getNotifications() {
    const headers = this.getAuthHeaders();
    const response = await this.axiosInstance.get(`${this.API}/admin/notifications`, {
      headers,
    });
    return response.data;
  }

  static async getUnreadCount() {
    const headers = this.getAuthHeaders();
    const response = await this.axiosInstance.get(
      `${this.API}/admin/notifications/unread-count`,
      { headers },
    );
    return response.data;
  }

  static async markAsRead(id) {
    const headers = this.getAuthHeaders();
    const response = await this.axiosInstance.post(
      `${this.API}/admin/notifications/${id}/read`,
      {},
      { headers },
    );
    return response.data;
  }
}

